import { render, staticRenderFns } from "./userCenterMain.vue?vue&type=template&id=def55586&scoped=true"
import script from "./userCenterMain.vue?vue&type=script&lang=js"
export * from "./userCenterMain.vue?vue&type=script&lang=js"
import style0 from "./userCenterMain.vue?vue&type=style&index=0&id=def55586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def55586",
  null
  
)

export default component.exports